module.exports = __webpack_public_path__ + "img/popupAd-day10.09e7d4a1.png";